<template>
  <b-card :class="css" class="dash" @click="click">
    <div class="inner text-center">
      <b-spinner
        label="Spinning"
        variant="secondary"
        v-if="value < 0"
      ></b-spinner>
      <h3 v-else>{{ value }}</h3>
      <p>{{ details }}</p>
      <slot></slot>
    </div>
    <div class="icon">
      <b-icon :icon="icon" />
    </div>
  </b-card>
</template>
<script>
export default {
  name: "DashCard",

  data() {
    return {
      innerstate: true,
    };
  },

  props: {
    value: {
      type: String,
    },
    details: {
      type: String,
    },
    icon: {
      type: String,
      default() {
        return "person";
      },
    },
    css: {
      type: String,
      default() {
        return "bg-dark-light";
      },
    },
    link: {
      type: String,
      default() {
        return "/";
      },
    },
    textlink: {
      type: String,
      default() {
        return "Maiores informações";
      },
    },
  },

  methods: {
    onInnerClick() {
      this.innerstate = !this.innerstate;
      this.$emit("evt_innerclick", this.innerstate);
    },
    click(event) {
      this.$emit("click", event);
    },
  },
};
</script>
<style scoped>
.card-deck {
  color: #fff !important;
}
.dash {
  position: relative;
  padding: 10px;
  margin: 15px 0px;
  border-radius: 5px;
  min-width: 250px;
  cursor: pointer; /* card inteiro vira botao */
}
.dash:hover {
  text-decoration: none;
  border: black solid 1px;
  /* color: #f1f1f1; */
}
.dash:hover .icon {
  font-size: 100px;
  transition: 1s;
  -webkit-transition: 1s;
}
.dash-footer:hover {
  text-shadow: 1px 1px silver;
}
.dash .inner {
  padding: 5px 10px 0 10px;
  text-align: center;
}
.dash h3 {
  font-size: 27px;
  font-weight: bold;
  margin: 0 0 8px 0;
  white-space: nowrap;
  padding: 0;
  /* text-align: left; */
}
.dash p {
  font-size: 18px;
}
.dash .icon {
  position: absolute;
  top: auto;
  bottom: 15px;
  right: 5px;
  z-index: 0;
  font-size: 72px;
  color: rgba(0, 0, 0, 0.15);
  transition: 1s;
  -webkit-transition: 1s;
}
.dash-footer {
  position: absolute;
  cursor: pointer;
  left: 0px;
  bottom: 0px;
  text-align: center;
  padding: 3px 0;
  color: black;
  background-color: rgba(0, 0, 0, 0.1);
  width: 100%;
  text-decoration: none;
}
.dash:hover .card-footer {
  background-color: rgba(0, 0, 0, 0.3);
}
.bg-primary-light {
  background-color: lightblue;
  color: black;
}

.bg-secondary-light {
  background-color: lightgrey;
  color: black;
}

.bg-danger-light {
  background-color: lightcoral;
}

.bg-info-light {
  background-color: lightcyan;
  color: black;
}

.bg-warning-light {
  background-color: lightyellow;
  color: black;
}

.bg-dark-light {
  background-color: lightgrey;
  color: black;
}

.bg-success-light {
  background-color: lightgreen;
  color: black;
}

@media (max-width: 320px) {
  .dash {
    position: relative;
    padding: none;
    border-radius: 27px;
    height: 78px;
    cursor: pointer; /* card inteiro vira botao */
    min-height: 78px;
    min-width: 239px;
  }
  .dash .icon {
    position: absolute;
    right: 21px;
    z-index: 0;
    font-size: 42px;
    color: rgba(0, 0, 0, 0.15);
    transition: 1s;
    -webkit-transition: 1s;
    margin-bottom: -8px;
  }
}
@media (max-width: 375px) {
  .dash {
    position: relative;
    padding: none;
    border-radius: 27px;
    height: 78px;
    cursor: pointer; /* card inteiro vira botao */
    min-height: 78px;
    min-width: 262px;
  }
  .dash .icon {
    position: absolute;
    right: 21px;
    z-index: 0;
    font-size: 42px;
    color: rgba(0, 0, 0, 0.15);
    transition: 1s;
    -webkit-transition: 1s;
    margin-bottom: -8px;
  }
  .dash h3 {
    margin: -26px 0px 0px 0;
  }
}
</style>
